import { condensedStyles } from 'core/components/theme/condensed-layout';

// The side column is pulled up so its first section heading lines up with the page title
export const SIDE_COLUMN_PULL_UP = 46;

// Condensed layout: the side column keeps its design width and the content column fills what is left.
// Below small_desktop the two stack in DOM order (side first) so nothing is clipped.
export const STEP_RAIL_WIDTH = 210;

// With a rail (condensed Modify Quote): rail, content, then the side column on the right, as in the prototype's
// quote page. Below standard_desktop the rail moves above the content; below tablet the columns stack.
export const RAIL_ON_TOP_BELOW = 'standard_desktop';
export const styles = (theme) => {
  const stacked = `@media (max-width: ${theme.screens.small_desktop - 1}px)`;
  const railOnTop = `@media (max-width: ${theme.screens[RAIL_ON_TOP_BELOW] - 1}px)`;
  const railStacked = `@media (max-width: ${theme.screens.tablet - 1}px)`;
  return {
    container: {
      marginBottom: 200,
      ...condensedStyles(theme, { flexWrap: 'wrap', gap: theme.spacing(8) })
    },
    side: {
      marginTop: -SIDE_COLUMN_PULL_UP,
      width: theme.sizes.sideColumn,
      ...condensedStyles(theme, {
        width: '100%',
        maxWidth: theme.sizes.sideColumn,
        flex: `0 0 ${theme.sizes.sideColumn}px`,
        [stacked]: { marginTop: 0, maxWidth: 'none', flex: '1 1 100%' }
      })
    },
    withRail: {
      flexWrap: 'nowrap',
      gap: theme.spacing(6),
      marginBottom: theme.spacing(10),
      '& $side': { order: 2, flex: '0 0 300px', maxWidth: 300, marginTop: 0 },
      '& $content': { order: 1, flex: '1 1 0' },
      [railOnTop]: {
        flexWrap: 'wrap',
        '& $rail': { flex: '1 1 100%' },
        '& $side': { marginTop: 0 }
      },
      [railStacked]: {
        '& $side': { order: 1, maxWidth: 'none', flex: '1 1 100%' },
        '& $content': { order: 2, flex: '1 1 100%' }
      }
    },
    rail: {
      order: 0,
      flex: `0 0 ${STEP_RAIL_WIDTH}px`
    },
    content: {
      width: 720,
      ...condensedStyles(theme, {
        width: 'auto',
        minWidth: 0,
        flex: '1 1 480px',
        [stacked]: { flex: '1 1 100%' }
      })
    }
  };
};
